import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Question} from 'shared/models/questions/question';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';

@Component({
  selector: 'modal-add-text',
  templateUrl: './modal-add-text.component.html',
  styleUrls: ['./modal-add-text.component.css'],
})
export class ModalAddTextComponent {

  @ViewChild('modal') private modal: any; // tslint:disable-line:no-any
  @Output() private confirm: EventEmitter<any> = new EventEmitter(); // tslint:disable-line:no-any
  @Output() private cancel: EventEmitter<any> = new EventEmitter(); // tslint:disable-line:no-any

  @Input() public groups: Array<string>;
  @Input() public title: string;
  public filteredGroups: Array<string>;
  public fieldsToSearch: Array<Array<string>> = [];

  public text: string;

  public show(): ModalAddTextComponent {
    this.modal.show();
    return this;
  }

  public hide(): ModalAddTextComponent {
    this.modal.hide();
    return this;
  }

  public setGroups(groups: Array<string>): ModalAddTextComponent {
    this.groups = groups;
    this.prepareFieldsToSearch();
    return this;
  }

  public setText(text: string): ModalAddTextComponent {
    this.text = text;
    return this;
  }

  public doConfirm(selectedGroup: string): void {
    this.hide();
    this.confirm.emit({text: this.text, group: selectedGroup});
  }

  public doCancel(): void {
    this.hide();
    this.cancel.emit(null);
  }

  public filterGroups(eventQuestions: Array<string>): void {
    this.filteredGroups = eventQuestions;
  }

  private prepareFieldsToSearch(): void {
    this.groups.forEach((group) => {
      this.fieldsToSearch.push([
        group.toLowerCase(),
      ]);
    });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/apptexts/modal-add-text/modal-add-text.component.ts